module.exports = __webpack_public_path__ + "img/csj.e60f5474.gif";